import React from "react";
import { Settings as SettingsIcon, Globe, Server, Key } from "lucide-react";
import PageHeader from "../../components/PageHeader";

const Settings = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumb="Controle & Segurança"
        title="Parâmetros Globais"
        subtitle="Configurações gerais do sistema e endpoints do ambiente"
      />

      <div className="neumorphic-card rounded-2xl p-8 border border-white/5 space-y-6">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-purple-500/10 border border-purple-500/20 text-purple-400 flex items-center justify-center">
            <SettingsIcon size={24} />
          </div>
          <div>
            <h3 className="text-base font-bold text-white">Configurações Gerais</h3>
            <p className="text-xs text-gray-400 mt-0.5">
              Definição de parâmetros da API backend e políticas globais
            </p>
          </div>
        </div>

        <div className="p-4 rounded-xl bg-white/5 border border-white/5 space-y-3 text-xs text-gray-300">
          <span className="font-bold text-gray-200 uppercase tracking-wider text-[11px] block">
            Informações do Ambiente:
          </span>
          <ul className="space-y-2">
            <li className="flex items-center justify-between border-b border-white/5 pb-2">
              <span className="flex items-center gap-2 font-medium">
                <Globe size={14} className="text-purple-400" /> URL da API Backend:
              </span>
              <span className="font-mono text-purple-300">{process.env.REACT_APP_BACKEND_URL || "Configuração via .env"}</span>
            </li>
            <li className="flex items-center justify-between border-b border-white/5 pb-2">
              <span className="flex items-center gap-2 font-medium">
                <Server size={14} className="text-purple-400" /> Versão da Plataforma:
              </span>
              <span className="font-mono text-emerald-400">TicketWhats Admin v1.0.0</span>
            </li>
            <li className="flex items-center justify-between">
              <span className="flex items-center gap-2 font-medium">
                <Key size={14} className="text-purple-400" /> Autenticação JWT:
              </span>
              <span className="font-mono text-purple-300">Ativa (Superadmin Role Required)</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Settings;
